<template lang="pug">
  .grid-item.grid-interest-block
    RouterLink.grid-block.interest-block(
      :to="{ name: 'interestPage', params: { slug: entity.slug}}"
      :class="{ 'is-liked': isLiked  }"
    )
      .ib-title(ref="title" :class="{ condensed: isCondensed }") {{ entity.name | truncate(55) }}
      .ib-count
        template(v-if="isUserProfile")
          | {{ entity.visitCount }}
          icon(data="~@/assets/svg/eye.svg" width="1.6rem" height="1.6rem" :fill="false")
        template(v-else)
          | {{ entity.likesCount }}
          icon(data="~@/assets/svg/users.svg" width="1.6rem" height="1.6rem" :fill="false")
      .ib-last-activity {{ dateFormat }} ago
</template>

<script>
import { formatDistanceToNowStrict, parseISO } from 'date-fns'

export default {
  props: {
    entity: { type: Object, required: true },
  },

  data() {
    return {
      isCondensed: false,
    }
  },

  computed: {
    dateFormat,
    isLiked,
    isUserProfile,
    likeCountText,
  },

  watch: {
    '$breakpoint.isTouch': {
      immediate: true,
      async handler(newValue) {
        await this.$nextTick()

        if (newValue) {
          const divHeight = this.$refs.title.offsetHeight
          const lineHeight = parseFloat(window.getComputedStyle(this.$refs.title)['line-height'])
          const lines = divHeight / lineHeight

          if (lines >= 4) this.isCondensed = true
        } else {
          this.isCondensed = false
        }
      },
    },
  },

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
function dateFormat() {
  let date
  if (this.isUserProfile) {
    date = this.entity?.visitedAt
  } else {
    date = this.entity?.lastLikeAt || this.entity.createdAt
  }

  return formatDistanceToNowStrict(parseISO(date))
}

function isLiked() {
  const currentUserProfile = this.$app?.user?.username == this.$route?.params?.slug
  return this.entity.liked && !currentUserProfile
}

function isUserProfile() {
  return this.$route.name == 'peopleShow'
}

function likeCountText() {
  const text = this.$options.filters.pluralize('Like', 'Likes', this.entity.likesCount)
  return `${this.entity.likesCount} ${text}`
}

/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
